import { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  supplier_name: "",
  unloading_date_from: "",
  status: "",
};

const UnloadingFilter = ({ onApplyFilter, onClose, filters = {} }) => {
  const [filtersData, setFiltersData] = useState({
    supplier_name: filters.supplier_name || "",
    unloading_date_from: filters.unloading_date_from || "",
    status: filters.status || "",
  });

  const { _t } = useTranslator();

  // Sync when filters prop changes (e.g. dropdown reopens with updated parent state)
  useEffect(() => {
    setFiltersData({
      supplier_name: filters.supplier_name || "",
      unloading_date_from: filters.unloading_date_from || "",
      status: filters.status || "",
    });
  }, [filters.supplier_name, filters.unloading_date_from, filters.status]);
    const status = [
        {
            label: _t("still_counting", "Still counting"),
            value: "counting",
        },
        {
            label: _t("ready_for_washing", "Ready for washing"),
            value: "washing_ready",
        },
        {
            label: _t("washing_done", "Washing Done"),
            value: "washing_done",
        }
    ];

    const handleChange = (e) => {
        let { name, value } = e.target;
        setFiltersData({ ...filtersData, [name]: value });
    };


  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) onClose();
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) onClose();
  };


  return (
    <div className="dropdown_body">
        <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>


        <InputWithLabel
          label={_t("supplier_name", "Supplier Name")}
          type="text"
          name="supplier_name"
          value={filtersData.supplier_name}
          onChange={handleChange}
        />

        <InputWithLabel
          label={_t("after_unloading_date", "After Unloading Date")}
          type="date"
          name="unloading_date_from"
          value={filtersData.unloading_date_from}
          onChange={handleChange}
        />

        <SelectBox
          label={_t("status", "status")}
          name="status"
          value={filtersData.status}
          onChange={handleChange}
          options={status?.map((list) => ({
              value: list.value,
              label: _t(list.label, list.label),
          }))}
        />


      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default UnloadingFilter;
